import { render, staticRenderFns } from "./zg.vue?vue&type=template&id=9e1f1cb8"
import script from "./zg.vue?vue&type=script&lang=js"
export * from "./zg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports